/*rutas de customer*/
import Customer from '@/apps/billing/views/Customer';
export default [
  {
    path: 'customer',
    name: 'Customer',
    folder: Customer,
  }
];
